import get from 'lodash.get';

const getMessage = (rootState) => get(rootState, 'ui.overlayLoader.message', null);

export default getMessage;
